import React, { useState } from "react";
import HeroAnimation from "../components/Homepage/HeroAnimation";
import NewsLetter from "../components/Homepage/NewsLetter";
import toast from "react-hot-toast";
import axios from "axios";

const newsletterImage =
  "https://storage.googleapis.com/think41-web-new/assets/Career/newsletter_callout-min.png";

const ContactUs = () => {
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  console.log(API_BASE_URL);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Newsletter subscribe handler
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!newsletterEmail) {
      toast.error("Please enter an email address.", {
        style: { fontFamily: 'Roboto, sans-serif' }
      });
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}subscribe`, {
        email: newsletterEmail,
      });

      toast.success("Subscribed successfully!" || response.data.message, {
        style: { fontFamily: 'Roboto, sans-serif' }
      });
      setNewsletterEmail("");
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.detail || "Subscription failed.", {
          style: { fontFamily: 'Roboto, sans-serif' }
        });
      } else {
        toast.error("An error occurred. Please try again.", {
          style: { fontFamily: 'Roboto, sans-serif' }
        });
      }
    }
  };

  // ✅ Contact message handler
  const handleSendMessage = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (!name || !email || !message) {
      toast.error("Please fill in all fields.", {
        style: { fontFamily: 'Roboto, sans-serif' }
      });
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}contact`, {
        name,
        email,
        message,
      });

      toast.success(response.data.message || "Message sent!", {
        style: { fontFamily: 'Roboto, sans-serif' }
      });
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.detail || "Message sending failed.", {
          style: { fontFamily: 'Roboto, sans-serif' }
        });
      } else {
        toast.error("An error occurred. Please try again.", {
          style: { fontFamily: 'Roboto, sans-serif' }
        });
        console.log(error);
      }
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col justify-between">
      {/* Top Section */}
      <div className=" md:min-h-screen flex flex-col w-full bg-white pt-16 relative overflow-hidden">
        <HeroAnimation />
        <div className="w-full max-w-[1200px] mx-auto px-5 md:px-8 relative z-10">
          <div className="flex flex-col md:flex-row gap-[60px] items-start">
            {/* Left Section */}
            <div className="flex flex-col items-start w-full md:w-1/2">
              <div className="flex flex-col gap-6">
                <h1 className="font-montserrat font-semibold text-[32px] md:text-[50px] bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent leading-[133.1%]">
                  Get in Touch
                </h1>
                <p className="font-roboto text-[16px] md:text-[24px] font-light text-[#232323] leading-[22px] md:leading-[32px] max-w-[410px]">
                  Have a question or an idea? We’re here to listen.
                </p>
              </div>
            </div>

            {/* Right Section: Form */}
            <form className="w-full md:w-1/2" onSubmit={handleSendMessage}>
              <div className="border border-[#A6A6A6] bg-white rounded-[4px] p-5 flex flex-col justify-between h-full">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="flex flex-col gap-1 w-full">
                    <label
                      htmlFor="name"
                      className="text-[#030303] font-roboto font-semibold text-[16px] leading-[20px]"
                    >
                      Name
                    </label>
                    <input
                      id="name"
                      type="text"
                      value={name}
                      placeholder="Enter your Name"
                      onChange={(e) => setName(e.target.value)}
                      className="border-b border-[#E2E2E2] text-[16px] font-roboto font-light p-1 focus:outline-none focus:border-[#0060C7]"
                    />
                  </div>

                  <div className="flex flex-col gap-1 w-full">
                    <label
                      htmlFor="email"
                      className="text-[#030303] font-roboto font-semibold text-[16px] leading-[20px]"
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      placeholder="Enter your Email"
                      onChange={(e) => setEmail(e.target.value)}
                      className="border-b border-[#E2E2E2] text-[16px] font-roboto font-light p-1 focus:outline-none focus:border-[#0060C7]"
                    />
                  </div>
                </div>

                <div className="flex flex-col mt-8">
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Write a Message ..."
                    className="w-full h-[120px] border border-[#D9D9D9] rounded-[4px] bg-[#FAFAFA] p-3 text-[16px] font-roboto font-light resize-none focus:outline-none focus:border-[#0060C7]"
                  />
                </div>

                {/* Submit Button */}
                <div className="flex justify-end mt-6">
                  <button className="flex justify-center items-center w-[168px] py-[10px] px-[18px] rounded-[4px] bg-[#0060C7] text-white text-[13px] cursor-pointer font-roboto hover:bg-[#0050a7] transition-colors shadow-md">
                    {loading ? "Sending..." : "Send"}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="w-full mt-[36px] block md:hidden">
            <NewsLetter />
          </div>
          {/* Newsletter Section */}
          <div className="md:flex hidden relative mt-[100px] justify-center mb-[35px]">
            <img
              src={newsletterImage}
              alt="Newsletter"
              className="object-cover rounded-[8px] max-w-full w-full"
            />

            {/* Only Email and Subscribe Box (LEFT aligned) */}
            <form
              className="absolute left-[6%] flex flex-row items-center gap-3"
              style={{ marginTop: "165px", top: "0" }}
              onSubmit={handleSubscribe}
            >
              <input
                type="email"
                placeholder="Your email address"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                className="flex flex-col items-start px-[13.397px] py-[6.14px] gap-[5.582px] rounded-[4.466px] bg-[#F1EFF0] w-[242.05px] h-[30.042px] text-[#232323] text-[14px] font-roboto focus:outline-none"
              />
              <button className="flex justify-center items-center px-[12px] py-[6.5px] gap-[4.593px] rounded-[8px] bg-t-blue-1 text-white text-[14px] font-roboto hover:bg-t-blue-3 transition-all cursor-pointer">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default ContactUs;
